import { CloudAPI } from '../../../../../shared/helpers/transport/cloud-api/types';
import { WaitingRoomPeerState } from '../../../types';

export const prepareWaitingRoomPeers = (
    waitingRoomPeers: CloudAPI.GetWaitingRoomPeers.Response['peers']
): WaitingRoomPeerState[] => {
    return waitingRoomPeers.map((peer) => ({
        id: peer.peer_id,
        uid: peer.state.uid,
        displayName: peer.state.display_name,
        avatarUrl: peer.state.avatar_url,
        waitingRoomEnteredAt: peer.waiting_room_entered_at,
        avatarPlaceholder: peer.state.avatar_placeholder
            ? {
                  abbreviation: peer.state.avatar_placeholder.abbreviation,
                  backgroundColor: peer.state.avatar_placeholder.background_color,
                  textColor: peer.state.avatar_placeholder.text_color,
              }
            : undefined,
        isDefaultAvatar: peer.state.is_default_avatar,
        version: peer.version,
        isAdmitting: false,
        peerType: peer.peer_type,
    }));
};
